export const validDomain = (value: string) => {
  const domain = value.split('@')[1];

  return /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(domain);
};
